(function () {
  const rootSelector = '[data-growtabs-root]';
  window.__growtabsProgramLoaded = true;

  function parseCopy(root) {
    const node = root.querySelector('[data-growtabs-copy]');
    if (!node) return {};
    try {
      return JSON.parse(node.textContent || '{}');
    } catch {
      return {};
    }
  }

  function emailInboxUrl(email) {
    const domain = String(email || '').split('@')[1]?.toLowerCase() || '';
    const providers = {
      'gmail.com': 'https://mail.google.com',
      'googlemail.com': 'https://mail.google.com',
      'outlook.com': 'https://outlook.live.com/mail/0/',
      'hotmail.com': 'https://outlook.live.com/mail/0/',
      'live.com': 'https://outlook.live.com/mail/0/',
      'yahoo.com': 'https://mail.yahoo.com',
      'icloud.com': 'https://www.icloud.com/mail',
      'me.com': 'https://www.icloud.com/mail',
      'gmx.de': 'https://www.gmx.net',
      'web.de': 'https://web.de',
      'proton.me': 'https://mail.proton.me',
      'protonmail.com': 'https://mail.proton.me'
    };
    return providers[domain] || 'mailto:';
  }

  function formDataObject(form) {
    const payload = {};
    const fd = new FormData(form);
    for (const [key, value] of fd.entries()) {
      payload[key] = typeof value === 'string' ? value.trim() : value;
    }
    ['accepted_18_plus', 'accepted_test_terms', 'accepted_program_contact', 'accepted_feedback_commitment', 'accepted_no_claim', 'marketing_newsletter_requested'].forEach(key => {
      payload[key] = form.elements[key]?.checked || false;
    });
    payload.email = String(payload.email || '').trim().toLowerCase();
    payload.locale = payload.locale || form.closest(rootSelector)?.dataset.locale || 'de';
    return payload;
  }

  function setHiddenContext(root, form) {
    const currentUrl = new URL(window.location.href);
    const path = `${currentUrl.pathname}${currentUrl.search}`;
    const fields = {
      landing_path: path,
      utm_source: currentUrl.searchParams.get('utm_source') || '',
      utm_medium: currentUrl.searchParams.get('utm_medium') || '',
      utm_campaign: currentUrl.searchParams.get('utm_campaign') || '',
      utm_content: currentUrl.searchParams.get('utm_content') || '',
      utm_term: currentUrl.searchParams.get('utm_term') || '',
      locale: root.dataset.locale || 'de',
      source: root.dataset.source || 'growtabs_testprogramm_landingpage',
      event: root.dataset.event || 'mary_jane_berlin_2026'
    };
    Object.entries(fields).forEach(([name, value]) => {
      const field = form.elements[name];
      if (field) field.value = value;
    });
  }

  function clearErrors(form) {
    form.querySelectorAll('[data-error-for]').forEach(node => {
      node.textContent = '';
    });
    form.querySelectorAll('.is-invalid').forEach(node => {
      node.classList.remove('is-invalid');
    });
    form.querySelectorAll('[aria-invalid="true"]').forEach(node => {
      node.removeAttribute('aria-invalid');
    });
  }

  function setFieldError(form, fieldName, message) {
    const target = form.querySelector(`[data-error-for="${fieldName}"]`);
    if (target) target.textContent = message || '';
  }

  function fieldElement(form, fieldName) {
    return form.elements?.[fieldName] || form.querySelector(`[name="${fieldName}"]`);
  }

  function markFieldInvalid(form, fieldName) {
    if (fieldName === 'consents') {
      const block = form.querySelector('.growtabs-form__consent-block');
      if (block) block.classList.add('is-invalid');
      return block;
    }
    const field = fieldElement(form, fieldName);
    if (!field) return null;
    field.setAttribute('aria-invalid', 'true');
    const wrapper = field.closest('.growtabs-form__field, .growtabs-form__checkbox');
    if (wrapper) wrapper.classList.add('is-invalid');
    return field;
  }

  function focusFirstInvalid(form) {
    const firstField = form.querySelector('[aria-invalid="true"]');
    if (firstField && typeof firstField.focus === 'function') {
      firstField.focus({ preventScroll: true });
      firstField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    const invalidBlock = form.querySelector('.growtabs-form__consent-block.is-invalid');
    if (invalidBlock) invalidBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function setState(root, options) {
    const state = root.querySelector('[data-growtabs-state]');
    if (!state) return;
    if (!options) {
      state.hidden = true;
      state.className = 'growtabs-state';
      state.innerHTML = '';
      return;
    }
    state.hidden = false;
    state.className = `growtabs-state ${options.tone ? `is-${options.tone}` : ''}`.trim();
    const actions = [];
    if (options.inboxUrl && options.inboxLabel) {
      actions.push(`<a class="growtabs-button growtabs-button--primary" href="${options.inboxUrl}" target="_blank" rel="noopener">${options.inboxLabel}</a>`);
    }
    state.innerHTML = `
      <h3>${options.title || ''}</h3>
      ${options.body ? `<p>${options.body}</p>` : ''}
      ${options.note ? `<p>${options.note}</p>` : ''}
      ${actions.length ? `<div class="growtabs-state__actions">${actions.join('')}</div>` : ''}
    `;
  }

  function clientValidate(form, copy) {
    const values = formDataObject(form);
    const requiredFields = ['first_name', 'last_name', 'email', 'phone', 'country_code', 'experience_level', 'grow_method', 'active_grow', 'test_reason'];
    let hasError = false;
    requiredFields.forEach(field => {
      if (!values[field]) {
        hasError = true;
        setFieldError(form, field, copy?.errors?.required || 'Bitte alle Pflichtfelder ausfüllen.');
        markFieldInvalid(form, field);
      }
    });
    if (values.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
      hasError = true;
      setFieldError(form, 'email', copy?.errors?.email || 'Bitte eine gültige E-Mail-Adresse eingeben.');
      markFieldInvalid(form, 'email');
    }
    const consentFields = ['accepted_18_plus', 'accepted_test_terms', 'accepted_program_contact', 'accepted_feedback_commitment', 'accepted_no_claim'];
    if (consentFields.some(field => !values[field])) {
      hasError = true;
      setFieldError(form, 'consents', copy?.errors?.required || 'Bitte alle Pflichtfelder ausfüllen.');
      markFieldInvalid(form, 'consents');
    }
    if (hasError) focusFirstInvalid(form);
    return !hasError;
  }

  async function submitForm(root, form, copy) {
    clearErrors(form);
    if (!clientValidate(form, copy)) return;
    const submitButton = form.querySelector('[data-growtabs-submit]');
    const originalLabel = submitButton?.textContent || '';
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = '…';
    }
    try {
      const response = await fetch(root.dataset.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formDataObject(form))
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(payload.error || copy?.errors?.generic || 'Die Registrierung konnte nicht gespeichert werden.');
      const success = payload.success || copy.success || {};
      form.hidden = true;
      setState(root, {
        tone: 'success',
        title: success.title,
        body: success.body,
        note: [success.note, success.spam].filter(Boolean).join(' '),
        inboxUrl: emailInboxUrl(formDataObject(form).email),
        inboxLabel: success.inbox
      });
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (error) {
      setState(root, {
        tone: 'error',
        title: copy?.errors?.generic || 'Fehler',
        body: error.message || copy?.errors?.generic || ''
      });
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = originalLabel;
      }
    }
  }

  function applyReturnState(root, copy) {
    const state = new URL(window.location.href).searchParams.get('growtabs_state');
    if (!state) return;
    if (state === 'verified') {
      setState(root, {
        tone: 'success',
        title: copy?.verified?.verified || '',
        body: copy?.success?.body || ''
      });
      return;
    }
    if (state === 'expired') {
      setState(root, {
        tone: 'warning',
        title: copy?.verified?.expired || '',
        body: copy?.success?.body || ''
      });
      return;
    }
    if (state === 'invalid') {
      setState(root, {
        tone: 'error',
        title: copy?.verified?.invalid || '',
        body: copy?.success?.body || ''
      });
    }
  }

  function initRoot(root) {
    const form = root.querySelector('[data-growtabs-form]');
    if (!form) return;
    window.__growtabsProgramInitialized = true;
    document.body.classList.add('growtabs-page');
    document.documentElement.classList.add('growtabs-page');
    const copy = parseCopy(root);
    setHiddenContext(root, form);
    applyReturnState(root, copy);
    form.querySelectorAll('input, select, textarea').forEach(field => {
      const resetField = () => {
        const wrapper = field.closest('.growtabs-form__field, .growtabs-form__checkbox');
        if (wrapper) wrapper.classList.remove('is-invalid');
        field.removeAttribute('aria-invalid');
        const error = form.querySelector(`[data-error-for="${field.name}"]`);
        if (error) error.textContent = '';
        if (field.type === 'checkbox') {
          const consentError = form.querySelector('[data-error-for="consents"]');
          if (consentError && !['accepted_18_plus', 'accepted_test_terms', 'accepted_program_contact', 'accepted_feedback_commitment', 'accepted_no_claim'].some(name => !form.elements[name]?.checked)) {
            consentError.textContent = '';
            form.querySelector('.growtabs-form__consent-block')?.classList.remove('is-invalid');
          }
        }
      };
      field.addEventListener('input', resetField);
      field.addEventListener('change', resetField);
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      await submitForm(root, form, copy);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(rootSelector).forEach(initRoot);
  });
})();
